/**
 * UpgradeRequiredModal Component
 *
 * Modal shown when a demo mode user attempts a restricted action.
 * Prompts them to upgrade to a paid plan to unlock the feature.
 */

'use client';

import { useLanguage } from '@/lib/platform/contexts/language-context';
import { getTranslation } from '@/lib/platform/data/translations';
import { DEMO_MODE } from '@/lib/platform/config/constants';
import ConfirmModal from '../modals/ConfirmModal';

interface UpgradeRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function UpgradeRequiredModal({ isOpen, onClose }: UpgradeRequiredModalProps) {
  const { locale } = useLanguage();
  const t = getTranslation(locale);

  const handleUpgrade = () => {
    onClose();
    // Open pricing page in new window
    window.open(DEMO_MODE.UPGRADE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <ConfirmModal
      open={isOpen}
      onClose={onClose}
      onConfirm={handleUpgrade}
      title={t.demoMode.title}
      message={t.demoMode.message}
      confirmText={t.demoMode.viewPlans}
      cancelText={t.demoMode.close}
      isDestructive={false}
    />
  );
}

export default UpgradeRequiredModal;
